import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';

@Component({
  selector: 'page-read-profile',
  templateUrl: 'read-profile.component.html'
})
export class ReadProfilePageComponent implements OnInit, OnDestroy {
  public profileData: any;
  public alive = true;

  constructor(
    private profileService: ProfileService
  ) {
  }

  ngOnInit() {
    this.getProfileData();
  }

  ngOnDestroy() {
    this.alive = false;
  }

  private getProfileData() {
    this.profileService.getProfileData()
      .takeWhile(() => this.alive)
      .subscribe(response => {
        this.profileData = response[0];
        if (this.profileData.imagePath && !this.profileData.imagePath.match(/^(https?:\/\/)/gi)) {
          this.profileData.imagePath = window.localStorage.getItem(Storage.DATASTORE) + 'PersonImages/' + this.profileData.imagePath;
        }
      }, error => {
        console.log("error occured while fetching profile data");
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/resume/read-profile/read-profile.component.ts